import basicAppConfig, {} from "../constants/basicAppConfig";
import createAppLogger from "./createAppLogger";
export const buildLoggerConfig = (config) => ({
    appId: config.applicationId || config.appName,
    env: config.mode,
    platform: config.platform,
    appVersion: config.appVersion,
});
const appLogger = createAppLogger(buildLoggerConfig(basicAppConfig));
export default appLogger;
